/**
 * Application constants.
 */

export const DATA_VERSION = '4.0'

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
  'Jan',
  'Feb',
  'Mar',
  'Apr',
] as const

// Engine constants
export const SELF_CONS_SOLAR_ONLY = 0.35
export const BATTERY_USABLE_FRAC = 0.95
export const BATTERY_ROUND_TRIP = 0.90
export const NIGHT_WINDOW_HOURS = 10
export const DAYS_IN_MONTH = 30.4
export const DAYS_IN_WEEK = 7
export const WEEKS_IN_MONTH = 4.345
export const MONTHS_IN_YEAR = 12

